// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[dir] .backgroundImage--2JDAE {\n  background-image: url('/dist/src/img/backgrounds/grey_background.png');\n  background-size: cover;\n  padding-bottom: 70px;\n}\n\n.backgroundWhite--37Iqk {\n  position: relative;\n}\n\n[dir] .backgroundWhite--37Iqk {\n  background-color: white;\n  padding: 25px;\n  margin-top: 15px;\n  border-radius: 14px;\n}\n\n.infoIcon--1kmL5 {\n  position: absolute;\n  top: 15px;\n\n  color: #a4a4a4;\n  transition: color 0.6s ease;\n\n  &:hover {\n    color: #e6512d;\n  }\n}\n\n[dir] .infoIcon--1kmL5 {\n  cursor: pointer\n}\n\n[dir=ltr] .infoIcon--1kmL5 {\n  right: 15px\n}\n\n[dir=rtl] .infoIcon--1kmL5 {\n  left: 15px\n}\n", ""]);
// Exports
exports.locals = {
	"backgroundImage": "backgroundImage--2JDAE",
	"backgroundWhite": "backgroundWhite--37Iqk",
	"infoIcon": "infoIcon--1kmL5"
};
module.exports = exports;
